(ns practitest.frontend.components2.entity-form
  (:require
    [clojure.string :as str]
    [practitest.frontend.common.i18n :refer [format-translation
                                             get-translation]]
    [practitest.frontend.components.card-view]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.misc-components :as misc-components]
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::steps-tab-hidden?
  (fn [[_ form-id]]
    (re-frame/subscribe [::forms/form-state form-id]))
  (fn [form-state _]
    (:steps-tab-hidden? form-state)))

(defn last-state-hide-steps-tab-key [form-id entity-id]
  (when-not (str/blank? entity-id)
    (str form-id ":last-state-hide-steps-tab-key:" entity-id)))

(re-frame/reg-event-db
  ::set-hide-steps-tab
  (fn [db [_ form-id entity-id hide?]]
    (when-let [k (last-state-hide-steps-tab-key form-id entity-id)]
      (.setItem js/sessionStorage k hide?))
    (assoc-in db [:form-states2 form-id :steps-tab-hidden?] hide?)))

(re-frame/reg-event-fx
  ::restore-hidden-steps-tab
  (fn [{:keys [db]} [_ form-id entity-id]]
    (let [hidden-steps-tab
                       (some->> (last-state-hide-steps-tab-key form-id entity-id)
                                (.getItem js/sessionStorage))]
      (when hidden-steps-tab
        (let [hidden-steps-tab (= hidden-steps-tab "true")]
          {:fx [[:dispatch [::set-hide-steps-tab form-id entity-id hidden-steps-tab]]]})))))

(re-frame/reg-event-db
  ::set-notification-state
  (fn [db [_ form-id state]]
    (assoc-in db [:form-states form-id :status] state)))

;; TODO: merge with form3 and replace in bugtracker modal
(defn display-form-errors [{:keys [get-field-props get-field-state]} form-errors form-ref toast-id]
  (let [body (apply conj
                    [:<> (get-translation "generic.error.mandatory-fields" "The following mandatory fields are not filled in: ")]
                    (interpose
                      ", "
                      (for [[field validation-state] form-errors]
                        (let [field-props @(get-field-props field)
                              field-state @(get-field-state field)]
                          [misc-components/link-button
                           {:on-click (fn [e]
                                        (forms/scroll-to-field form-ref field-props field-state))}
                           (:label field-props)]))))]
    (notifications/notify! body
                           {:type       "error"
                            :auto-close false
                            ;; Single notification
                            :id         toast-id})))

(defn breadcrumbs-view [{:keys [breadcrumbs
                                entity-type
                                base-entity
                                new?
                                section]}]
  [:div.breadcrumbs-container
   [:div.breadcrumbs-back
    {:on-click #(js/history.back)}
    [icons/mux-arrow-left3]]
   (for [item breadcrumbs]
     [:<>
      {:key (:href item)}
      [:a.breadcrumbs-item
       {:href (:href item)}
       (:label item)]
      [:span.breadcrumbs-delimiter
       [icons/mux-chevron-right]]])
   [:span
    (when (and entity-type base-entity)
      (if new?
        (str "New " (forms/entity->display-name entity-type))
        (str (forms/entity->display-name entity-type) " #" (:display_id base-entity))))
    (when section
      section)]])
